











import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import Datepicker from 'vuejs-datepicker';
import {formatDate} from '@/utils';

@Component({
    components: {
        Datepicker
    }
})
export default class DatepickerComponent extends Vue {
    @Prop() public disabledDates: any;

    @Prop() public value: Date;

    @Prop() public calendarAlignRight: boolean;

    public customFormatter(date) {
        return formatDate(date);
    }

}
